import { render, staticRenderFns } from "./AnadirDialogo.vue?vue&type=template&id=20ca2d00&scoped=true"
import script from "./AnadirDialogo.vue?vue&type=script&lang=js"
export * from "./AnadirDialogo.vue?vue&type=script&lang=js"
import style0 from "./AnadirDialogo.vue?vue&type=style&index=0&id=20ca2d00&prod&lang=scss"
import style1 from "./AnadirDialogo.vue?vue&type=style&index=1&id=20ca2d00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ca2d00",
  null
  
)

export default component.exports